import { Link } from "react-router-dom";
import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import {
  GetFindingsAndRecommendationsFetchUrl,
  IFindingAndRecommendation,
} from "../../api/IFindingAndRecommendation";
import { ILicenceProfile } from "../../api/LicenceProfile";
import { Grid } from "../Grid";
import { getIconForType } from "../icons/LeapIcons";
import { FindingsAndRecommendationsProps } from "./FIndingsAndRecommendationsProps";

const GetUrlForFindingAndRecommendation = (
  profileNumber: string,
  findingAndRecommendation: IFindingAndRecommendation
) => {
  return `/licence-profile/${profileNumber}/compliance/finding-and-recommendation/${findingAndRecommendation.taskid}`;
};

const formatObservation = (rowInfo: any) => {
  return <p dangerouslySetInnerHTML={{ __html: rowInfo.value }}></p>;
};

const FindingsAndRecommendationsGrid = ({
  profileNumber,
  regardingObjectId,
}: FindingsAndRecommendationsProps) => {
  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetFindingsAndRecommendationsFetchUrl(
        relatedId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(regardingObjectId);

  const tableColumnsBig: Column<Record<string, IFindingAndRecommendation>>[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "reference",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td style={{ paddingTop: "6px" }}>
              <span>{getIconForType("Finding and Recommendation")}</span>
            </td>
            <td>
              <Link
                to={GetUrlForFindingAndRecommendation(
                  profileNumber,
                  rowInfo.row.original
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Date",
      accessor: "datesubmitted",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Type",
      accessor: "type",
      Filter: false,
    },
    {
      Header: "Category",
      accessor: "category",
      Filter: false,
    },
    {
      Header: "Status",
      accessor: "status",
      Filter: false,
    },
    {
      Header: "Observation",
      accessor: "observation",
      Filter: false,
      Cell: (rowInfo: any) => formatObservation(rowInfo),
    },
  ];

  const tableColumnsSmall: Column<Record<string, IFindingAndRecommendation>>[] =
    [
      {
        Header: "Ref. No.",
        accessor: "reference",
        Filter: false,
        filter: "reference",
        Cell: (rowInfo: any) => (
          <table>
            <tr>
              <td style={{ paddingTop: "6px" }}>
                <span>{getIconForType("Finding and Recommendation")}</span>
              </td>
              <td>
                <Link
                  to={GetUrlForFindingAndRecommendation(
                    profileNumber,
                    rowInfo.row.original
                  )}
                >
                  {rowInfo.value}
                </Link>
              </td>
            </tr>
          </table>
        ),
      },
      {
        Header: "Date",
        accessor: "datesubmitted",
        Filter: false,
        filter: "includes",
        Cell: (rowInfo: any) => formatDate(rowInfo.value),
      },
      {
        Header: "Type",
        accessor: "type",
        Filter: false,
      },
      {
        Header: "Category",
        accessor: "category",
        Filter: false,
      },
      {
        Header: "Status",
        accessor: "status",
        Filter: false,
      },
    ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { FindingsAndRecommendationsGrid };
